import React from "react";
import { Card, Row, Col, Table, Typography } from "antd";

const { Title } = Typography;

export default function CollectionTab({
  collectionVsTarget = [],
  collectionCustomerwise = [],
  collectionAgingwiseWOTax = [],
}) {
  const cardStyle = {
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    backgroundColor: "#fff",
    marginBottom: 16,
  };

  const tableProps = {
    size: "small",
    pagination: { pageSize: 10 }, // Set default page size
    bordered: false,
    scroll: { x: 400, y: 500 },
  };

  const cardTitle = (text, color = "#333") => (
    <span style={{ fontSize: 16, fontWeight: 600, color }}>{text}</span>
  );

  const targetColumns = [
    { title: "Sales Employee", dataIndex: "SlpName", key: "SlpName" },
    { title: "Collection", dataIndex: "Collection", key: "Collection", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "W/o Tax Coll.", dataIndex: "Collection_Without_Tax", key: "Collection_Without_Tax", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "%", dataIndex: "Collection_Without_Tax_Percentage", key: "Collection_Without_Tax_Percentage", align: "right" },
  ];

  const collectionCustomerwiseColumns = [
    { title: "Customer/Vendor Name", dataIndex: "CardName", key: "CardName" },
    { title: "Collection Amount", dataIndex: "Collection_Amount", key: "Collection_Amount", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  const collectionAgingwiseWOTaxColumns = [
    { title: "Sales Employee Name", dataIndex: "SlpName", key: "SlpName" },
    { title: "30 Days", dataIndex: "_30_Days", key: "_30_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "45 Days", dataIndex: "_45_Days", key: "_45_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "60 Days", dataIndex: "_60_Days", key: "_60_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Above 60 Days", dataIndex: "Above_60_Days", key: "Above_60_Days", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Advance", dataIndex: "Advance", key: "Advance", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
    { title: "Grand Total", dataIndex: "Grand_Total", key: "Grand_Total", align: "right", render: (val) => Number(val).toLocaleString("en-IN"), },
  ];

  return (
    <div className="sales-trend-tab" style={{ padding: 16 }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={12}>
          <Card
            title={cardTitle("Target Vs Actual Collection", "#1976d2")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={targetColumns}
              dataSource={collectionVsTarget}
              rowKey="SlpName"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                pageData.forEach(({ Collection, Collection_Without_Tax,  }) => {
                  totalQty += Number(Collection) || 0;
                  totalValue += Number(Collection_Without_Tax) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
        <Col xs={24} md={12}>
          <Card
            title={cardTitle("Current Month Actual Collection", "#1976d2")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={collectionCustomerwiseColumns}
              dataSource={collectionCustomerwise}
              rowKey="CardName"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                let totalTax = 0;
                pageData.forEach(({ Collection_Amount }) => {
                  totalQty += Number(Collection_Amount) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
        <Col xs={24}>
          <Card
            title={cardTitle("Ageing Wise Collection W/O-Tax", "#c62828")}
            style={cardStyle}
            bodyStyle={{ padding: 12 }}
          >
            <Table
              columns={collectionAgingwiseWOTaxColumns}
              dataSource={collectionAgingwiseWOTax}
              rowKey="SlpName"
              {...tableProps}
              summary={pageData => {
                let totalQty = 0;
                let totalValue = 0;
                let totalTax = 0;
                let above60 = 0;
                let advance = 0;
                let grandTotal = 0;
                pageData.forEach(({ _30_Days, _45_Days, _60_Days, Above_60_Days, Advance, Grand_Total }) => {
                  totalQty += Number(_30_Days) || 0;
                  totalValue += Number(_45_Days) || 0;
                  totalTax += Number(_60_Days) || 0;
                  above60 += Number(Above_60_Days) || 0;
                  advance += Number(Advance) || 0;
                  grandTotal += Number(Grand_Total) || 0;
                });
                return (
                  <Table.Summary.Row>
                    <Table.Summary.Cell><b>Grand Total</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalQty.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalValue.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{totalTax.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{above60.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{advance.toLocaleString()}</b></Table.Summary.Cell>
                    <Table.Summary.Cell align="right"><b>{grandTotal.toLocaleString()}</b></Table.Summary.Cell>
                  </Table.Summary.Row>
                );
              }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
